import { ConnectableElement, useDrag, useDrop } from "react-dnd";

export function useDragDrop({
  index,
  moveItem,
  onDrop,
}: {
  index: number;
  moveItem: (dragIndex: number, hoverIndex: number) => void;
  onDrop: (dragIndex: number, hoverIndex: number) => void;
}) {
  const [{ isDragging }, ref] = useDrag({
    type: "ITEM",
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [{ isOver }, drop] = useDrop({
    accept: "ITEM",
    hover: (draggedItem: { index: number }) => {
      if (draggedItem.index !== index) {
        moveItem(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
    drop: (draggedItem: { index: number }) => {
      // alert("Item dropped");
      onDrop(draggedItem.index, index);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  const ddRef = (node: ConnectableElement) => {
    if (typeof ref === "function") {
      ref(drop(node));
    }
  };
  return { ref, drop, ddRef, isOver, isDragging };
}
